var galleryThumbs = new Swiper(".template-product .gallery-thumbs", {
    centeredSlides: true,
    autoHeight: true,
    centeredSlidesBounds: true,
    direction: "horizontal",
    spaceBetween: 12,
    slidesPerView: 5,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    breakpoints: {
        480: {
            direction: "vertical",
            slidesPerView: 5
        }
    }
});
var galleryTop = new Swiper(".template-product .gallery-top", {
    direction: "horizontal",
    spaceBetween: 10, // gap of 10px
    slidesPerView: 1.2,
    slidesOffsetBefore:20,
    slidesOffsetAfter:20,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
    },
    keyboard: {
        enabled: true,
    },
    thumbs: {
        swiper: galleryThumbs
    },
    breakpoints: {
        749: {
            slidesPerView: 1,
            spaceBetween: 0,
            slidesOffsetBefore:0,
            slidesOffsetAfter:0,
        }
    }
});

// galleryTop.on("slideChangeTransitionStart", function () {
//     galleryThumbs.slideTo(galleryTop.activeIndex);
// });
// galleryThumbs.on("transitionStart", function () {
//     galleryTop.slideTo(galleryThumbs.activeIndex);
// });

document.addEventListener("DOMContentLoaded", function() {
    var sliderContainer = document.querySelector(".template-product .block__main-product-image-slider-container .gallery-top .swiper-slide img");
    if (sliderContainer) {
        var sliderContainerHeight = sliderContainer.offsetHeight;
        // console.log("Height of the element:", sliderContainerheight);
        var thumbsSwiperWrapper = document.querySelector(".template-product .block__main-product-image-slider-container .gallery-thumbs .swiper-wrapper");
        // console.log('thumbsSwiperWrapper',thumbsSwiperWrapper)
        // console.log('thumbsSwiperWrapper',thumbsSwiperWrapper.style.height = sliderContainerHeight + "px")
        if (thumbsSwiperWrapper) {
            thumbsSwiperWrapper.style.height = sliderContainerHeight - 100 + "px";
        }
    }
});

var galleryThumbs = new Swiper(".quick-add-modal__content-info .gallery-thumbs", {
    centeredSlides: true,
    autoHeight: true,
    centeredSlidesBounds: true,
    direction: "horizontal",
    spaceBetween: 12,
    slidesPerView: 5,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    breakpoints: {
        480: {
            direction: "vertical",
            slidesPerView: 5
        }
    }
});

var galleryTop = new Swiper(".quick-add-modal__content-info .gallery-top", {
    direction: "horizontal",
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
    },
    keyboard: {
        enabled: true,
    },
    thumbs: {
        swiper: galleryThumbs
    },
    breakpoints: {
        0: {
            spaceBetween: 10, // gap of 10px
            slidesPerView: 1.2,
        },
        749: {
            slidesPerView: 1,
            spaceBetween: 10, // gap of 10px
        }
    }
});